export const fileUploader = {
    data() {
        return {
            fileInputError: "",
            fileInputErrorOrgnip: "",
            fileInputErrorEgrip: "",
            fileInputErrorInn: "",
            fileInputErrorForm26: ""
        };
    },
    methods: {
        deleteFileById(id, target) {
            this.stepData[target].splice(id, 1);
        },
        uploadFile(file, target) {
            this.stepData[target].push({
                id: file.id,
                name: file.name,
                url: file.url
            });
            this.fileInputError = "";
            this.fileInputErrorOrgnip = "";
            this.fileInputErrorEgrip = "";
            this.fileInputErrorInn = "";
            this.fileInputErrorForm26 = "";
        }
    }
};
